import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ReportsTrackService {

  constructor(private http: HttpClient) { }

  getAllOrdersList(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ResGetRestaurantOrders`, filter);
  }
  ExportAllOrdersList(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ResExportRestaurantOrders`, filter, { responseType: 'blob' });
  }


  GetRestaurantMostMenuItem(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetRestaurantMostMenuItem`, filter);
  }
  ExportRestaurantMostMenuItem(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportRestaurantMostMenuItem`, filter, { responseType: 'blob' });
  }


  GetRestaurantWaiterAchievement(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetRestaurantWaiterAchievement`, filter);
  }
  ExportRestaurantWaiterAchievement(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportRestaurantWaiterAchievement`, filter, { responseType: 'blob' });
  }


  GetRestaurantCashierAchievement(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetRestaurantCashierAchievement`, filter);
  }
  ExportRestaurantCashierAchievement(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportRestaurantCashierAchievement`, filter, { responseType: 'blob' });
  }


  GetRestaurantHostAchievement(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetRestaurantHostAchievement`, filter);
  }
  ExportRestaurantHostAchievement(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportRestaurantHostAchievement`, filter, { responseType: 'blob' });
  }


  GetCashDrawerRepor(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetCashDrawerRepor`, filter);
  }
  ExportCashDrawerRepor(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportCashDrawerRepor`, filter, { responseType: 'blob' });
  }


  GetRestaurantAttendanceReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetRestaurantAttendanceReport`, filter);
  }
  ExportRestaurantAttendanceReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportRestaurantAttendanceReport`, filter, { responseType: 'blob' });
  }
  GetRestaurantAttendanceDetails(data: any) {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetRestaurantAttendanceDetails`, data);
  }
  GetRestaurantAttendanceOrders(data: any) {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetRestaurantAttendanceOrders`, data);
  }
  GetAllRestaurantAttendanceDetails(data: any) {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetAllRestaurantAttendanceDetails`, data);
  }


  GetRestaurantItemsSalesReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetRestaurantItemsSalesReport`, filter);
  }
  ExportRestaurantItemsSalesReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportRestaurantItemsSalesReport`, filter, { responseType: 'blob' });
  }


  GetRestaurantOrdersSummaryReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetRestaurantOrdersSummaryReport`, filter);
  }
  ExportRestaurantOrdersSummaryReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportRestaurantOrdersSummaryReport`, filter, { responseType: 'blob' });
  }

  // Export Fun
  exportReport(type: any, data: any, nameEn: string = 'Report', nameAr: string = 'تقرير') {
    let today = new Date();
    let extension = ''
    let blobType = ''

    if (type == 'EXCEL') {
      extension = 'xlsx';
      blobType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    }
    if (type == 'PDF' || type == 'Receipts') {
      extension = 'pdf';
      blobType = 'application/pdf'
    }
    let name = (localStorage.getItem('language') == 'en') ? nameEn : nameAr;
    let fileName = `${name}_${today.getDate()}-${today.getMonth() + 1}-${today.getFullYear()}.${extension}`
    var blob = new Blob([data], { type: blobType });
    FileSaver.saveAs(blob, fileName);
  }

  GetStaffFilter(restaurantId: number, roleName: string) {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetStaffFilter`, {
      restaurantId, roleName
    });
  }

  GetStuffFiltertipsreport(restaurantId: number) {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetStuffFiltertipsreport`, { restaurantId });
  }

  /***************************************/
  GetTobacooItems(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/OrdersReprot/GetTobacooItems?RestaurantId=${restaurantId}`);
  }
  GetTobaccoItemsReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetTobaccoItemsReport`, filter);
  }
  ExportTobaccoItemsReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportTobaccoItemsReport`, filter, { responseType: 'blob' });
  }
  /***************************************/

  GetGuestsOrdersReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetGuestsOrdersReport`, filter);
  }
  GetGuestsOrdersDetails(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetGuestsOrdersDetails`, filter);
  }
  ExportGuestsOrdersReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportGuestsOrdersReport`, filter, { responseType: 'blob' });
  }
  ExportGuestsOrdersDetails(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportGuestsOrdersDetails`, filter, { responseType: 'blob' });
  }

  GetRestaurantOrdersOfZatca(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetRestaurantOrdersOfZatca`, filter);
  }
  ResResendListFailedZatcaInvoices(data: any) {
    return this.http.post(`${environment.apiUrl}/ResCheckOut/ResResendListFailedZatcaInvoices`, data);
  }
  ResResendAllFailedZatcaInvoices(restId: string) {
    return this.http.get(`${environment.apiUrl}/ResCheckOut/ResResendAllFailedZatcaInvoices?restaurantId=${restId}`);
  }
  exportRestaurantOrdersOfZatca(data: any) {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportRestaurantOrdersOfZatca`, data, { responseType: 'blob' });
  }


  gettipsrestaurantreport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/gettipsrestaurantreport`, filter);
  }
  Exporttipsrestaurantreportt(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/Exporttipsrestaurantreportt`, filter, { responseType: 'blob' });
  }


  GetRestaurantOrdersWithTax(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetRestaurantOrdersWithTax`, filter);
  }
  ExportRestaurantOrdersWithTax(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportRestaurantOrdersWithTax`, filter, { responseType: 'blob' });
  }

  getSpeedofServicereport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/getSpeedofServicereport`, filter);
  }
  ExportSpeedofServicereport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportSpeedofServicereport`, filter, { responseType: 'blob' });
  }

  GetSalesbyBranchreport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetSalesbyBranchreport`, filter);
  }
  ExportSalesbyBranchreport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportSalesbyBranchreport`, filter, { responseType: 'blob' });
  }

  getingredientpurchasesordersreport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/getingredientpurchasesordersreport`, filter);
  }
  Exportingredientpurchasesordersreport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/Exportingredientpurchasesordersreport`, filter, { responseType: 'blob' });
  }

  getInventoryLevelsreport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/getInventoryLevelsreport`, filter);
  }
  ExportInventoryLevelsreport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportInventoryLevelsreport`, filter, { responseType: 'blob' });
  }

  getInventoryIngredientsCostReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/getInventoryIngredientsCostReport`, filter);
  }
  ExportInventoryIngredientsCostReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportInventoryIngredientsCostReport`, filter, { responseType: 'blob' });
  }

  GetAbsentGuest(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/GetAbsentGuest`, filter);
  }
  ExportGetAbsentGuest(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportGetAbsentGuest`, filter, { responseType: 'blob' });
  }

  Earningsreport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/Earningsreport`, filter);
  }
  ExportEarningsreport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportEarningsreport`, filter, { responseType: 'blob' });
  }

  WastedMenuItemsReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/WastedMenuItemsReport`, filter);
  }
  ExportWastedMenuItemsReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ExportWastedMenuItemsReport`, filter, { responseType: 'blob' });
  }

  // Delivery Orders
  getRestaurantDeliveryOrders(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ResGetRestaurantDeliveryOrders`, filter);
  }
  ExportRestaurantDeliveryOrders(filter: any): any {
    return this.http.post(`${environment.apiUrl}/OrdersReprot/ResExportRestaurantDeliveryOrders`, filter, { responseType: 'blob' });
  }

  // Neoleap Payment Report
  getNeoleapPaymentReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/NeoLeap/GetNeoLeapPaymentReport`, filter);
  }
  ExportNeoleapPaymentReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/NeoLeap/ExportGetNeoLeapPaymentReport`, filter, { responseType: 'blob' });
  }
  GetResNeoLeapUsersList(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/NeoLeap/GetResNeoLeapUsersList?restaurantId=${restaurantId}`);
  }
  GetTerminalListLookUp(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/NeoLeap/GetTerminalListLookUp?restaurantId=${restaurantId}`);
  }

  // Paymob Report
  GetPaymobReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/Paymob/GetPaymobReport`, filter);
  }
  ExportPaymobReport(filter: any): any {
    return this.http.post(`${environment.apiUrl}/Paymob/ExportPaymobReport`, filter, { responseType: 'blob' });
  }
  GetPaymobUsersList(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/Paymob/PaymobUsersList?restaurantId=${restaurantId}`);
  }
}
